<template>
<m-pageframe
    title="RedChirp Cron"
>
<v-container
    fluid
    style="padding: 15px"
>

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
        autofocus
        append-icon="mdi-reload"
        v-on:click:append="update"

    >
    </v-text-field>
           

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="filtered_results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
        :search="full_text"
    >
    
        <template v-slot:item.id="{ item }">
            <span style="font-family: monospace">{{item.id}}</span>
        </template>

        

        <template v-slot:item.last_run_date="{ item }">
            {{$rc.pretty(item.last_run_time,'date')}}
        </template>

        <template v-slot:item.last_run_time="{ item }">
            {{$rc.pretty(item.last_run_time,'time')}}
        </template>

        <template v-slot:item.process_state="{ item }">
            {{prettyState(item.process_state)}}
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickRun(item)"
                >
                    <v-list-item-title>Run...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const Time = require('@/js/time.js');
export default {
data() {
    return {
        results: [],
        full_text: null,
        include_tasks: true,
        include_processors: true,

        headers: [
            { text: 'Id', value: 'id'},
            { text: 'Description', value: 'description'},
            { text: 'Schedule', value: 'run_every_pretty_print'},
            { text: 'Last Date', value: 'last_run_date'},
            { text: 'Last Time', value: 'last_run_time'},
            { text: 'Run Count', value: 'run_count'},
            { text: 'State', value: 'process_state'},
            { text: 'Action', value: 'action'},
        ],
    }
},

mounted () {
    this.update();
},

methods: {
    update()
    {
        this.$rc.rest({
            'spinner': false,
            'endpoint': 'LIST: /api/v1/admin/tasks',
        
            'params' : {
                },
        
            'on_success': (data) => {
                    this.results = data.results;
                },
        
            'on_error': 'Unable to list tasks and processors',
        });
    },

    onExpandFirst()
    {

    },

    onClickRun(item)
    {
        this.$rc.confirm({
            'title': 'Run task: '+item.id,
            'body': '<p><b>Description</b></p><p>'+item.description+'</p>',
            'btn_text_ok': 'Run',
            'btn_text_cancel': 'Cancel',
            'on_ok': () => {
                this.$rc.rest({
                    'spinner': true,
                    'endpoint': 'PUT: /api/v1/admin/tasks/run',
                
                    'params' : {
                            'id': item.id,
                        },
                
                    'on_success': (data) => {
                            this.update();
                        },
                
                    'on_error': 'Unable to manually run task',
                });
            },
        });
    },

    prettyState(state)
    {
        if ( state == 'wait-for-trigger') return '';
        if ( state == 'wait-for-retry') return 'wait for retry';
        if ( state == 'ready-to-run') return 'ready';
        if ( state == 'running') return 'running';

        return state;
    },
},

computed: {
    filtered_results() {
        let ret = [];

        if ( this.results == null ) return ret;

        for ( let i = 0; i < this.results.length; i++ )
        {
            let cur = this.results[i];

            if ( !this.include_tasks && !cur.is_processor ) continue;
            if ( !this.include_processors && cur.is_processor ) continue;

            ret.push(cur);
        }

        return ret;
    }
},
}
</script>

<style lang="scss" scoped>
</style>